/**
 * Edge Elite Logo oficial del mockup v4.
 * Réplica EXACTA de window.EELogo en entregable_claude/mobile_data.jsx (líneas 6-36).
 *
 * Wordmark "Edge Elite" en Inter Tight + circulito naranja chico al final.
 * El text usa currentColor — funciona sobre fondos claros y oscuros.
 *
 * @param {number} size - font-size del texto en px (default 22, mismo que el mockup en auth screens)
 * @param {string} color - color del texto (default 'currentColor', hereda del padre)
 */
export default function EELogo({ size = 22, color = 'currentColor' }) {
  const dot = Math.round(size * 0.35);

  return (
    <div
      style={{
        fontFamily: '"Inter Tight", -apple-system, "SF Pro Display", system-ui, sans-serif',
        fontSize: size,
        fontWeight: 700,
        letterSpacing: '-0.04em',
        lineHeight: 1,
        color: color,
        display: 'inline-flex',
        alignItems: 'baseline',
        whiteSpace: 'nowrap',
      }}
    >
      Edge Elite
      <span
        aria-hidden="true"
        style={{
          display: 'inline-flex',
          width: dot,
          height: dot,
          marginLeft: Math.round(size * 0.08),
          alignSelf: 'flex-end',
          flex: 'none',
        }}
      >
        <svg viewBox="0 0 24 24" width={dot} height={dot} fill="none">
          <circle cx="12" cy="12" r="12" fill="#FF4D0D" />
          <path
            d="M6 6c3.2 2.6 3.2 9.8 0 12"
            stroke="#0A0A0C"
            strokeOpacity="0.55"
            strokeWidth="1.6"
            strokeLinecap="round"
            fill="none"
          />
        </svg>
      </span>
    </div>
  );
}
